import React, {Component} from "react";

class FaqCard extends Component{

    constructor(props){
        super(props);
        this.state = {
            show : false,
        }
    }
    
    render(){
        return(
            <div className="sec-bg faq-card">
                <i className={this.state.show ? "fi fi-rr-angle-up" : "fi fi-rr-angle-down"} onClick={() => this.setState({show : !this.state.show })}></i>
                <h4>{this.props.Question}</h4>

                {this.state.show ? <p className="small-txt sec-txt">{this.props.Answer}</p> : null }
                
            </div>
        )
    }
}

export default FaqCard;